import { createReducer, on } from '@ngrx/store';

import {
  login,
  loginSuccess,
  loginFailure,
  register,
  registerSuccess,
  registerFailure,
  logout,
  logoutSuccess,
  logoutFailure,
  updateUser,
  setIsLoggedIn,
  updateUserTestCode
} from './auth.actions';
import {resetState} from "../global/global.actions";

export interface AuthState {
  token: string | null;
  user: any | null;
  isLoggedIn: boolean;
  error: string;
  isLoading: boolean;
  logoutSuccess: boolean;
}

const initialState: AuthState = {
  token: null,
  user: null,
  isLoggedIn: false,
  error: null,
  isLoading: false,
  logoutSuccess: null,
};

export const authReducer = createReducer(
  initialState,
  on(login, (state) => {
    // console.log('Login started');
    return { ...state, loading: true, error: null };
  }),
  on(loginSuccess, (state, { token, user }) => {
    console.log('[AuthReducer] loginSuccess - Setting isLoggedIn to TRUE', { token, user });
    const newState = { ...state, token, user, isLoggedIn: true, loading: false, error: null };
    console.log('[AuthReducer] New state:', newState);
    return newState;
  }),
  on(loginFailure, (state, { error }) => {
    // console.log('Login failure', error);
    return { ...state, error, isLoggedIn: false, loading: false, token: null };
  }),
  on(logout, state => {
    console.log('[AuthReducer] logout - Resetting to initialState');
    return { ...initialState };
  }),
  on(register, (state) => {
    // console.log('Register started');
    return { ...state, loading: true, error: null };
  }),
  on(registerSuccess, (state, { user }) => {
    // console.log('Register success', user);
    return { ...state, user, loading: false, error: null };
  }),
  on(registerFailure, (state, { error }) => {
    // console.log('Register failure', error);
    return { ...state, error, loading: false, token: null };
  }),
  on(logoutSuccess, state => ({
    ...state,
    logoutSuccess: true,
    error: null
  })),
  on(logoutFailure, (state, { error }) => ({
    ...state,
    logoutSuccess: false,
    error
  })),
  on(updateUser, (state, { user }) => ({
    ...state,
    user: user
  })),
  on(setIsLoggedIn, (state, { isLoggedIn }) => ({
    ...state,
    isLoggedIn
  })),
  on(updateUserTestCode, (state, { testCode }) => ({
    ...state,
    user: state.user ? { ...state.user, test_code: testCode } : null
  })),

  // Handle reset state by returning initial state
  on(resetState, () => {
    console.log('[AuthReducer] resetState - Resetting to initialState');
    return initialState;
  })

  /*
  on(updateUserSuccess, (state, {  user }) => {
    // console.log('Login success', token);
    return { ...state,  user, isLoggedIn: true, loading: false, error: null };
  }),
  on(updateUserFailure, (state, { error }) => {
    // console.log('Login failure', error);
    return { ...state, error, loading: false,  };
  }),
  */
);
